
// Project number + name, kept as separate fields on purpose: joining them into
// one string makes the truncation eat the name in the narrow left menu card.
// The number is dropped when the name or the super project already starts with
// it, which is the case for the companies that prefix their project names.
export function project_label(project) {
    const number = (project?.project_number || "").trim()
    const name = project?.name || ""
    const superp = project?.super_project || ""
    const lower = number.toLowerCase()
    const redundant = !number
        || name.toLowerCase().startsWith(lower)
        || superp.toLowerCase().startsWith(lower)
    return { number, name, show_number: !redundant }
}

export function get_subsets_from_pl(pl) {
    let subsets = []
    pl.stations.forEach(sta => {
        sta.disabled_subsets.forEach(subset => {
            if (subset && !subsets.includes(subset)) subsets.push(subset)
        })
        sta.checklist_items?.forEach(chi => {
            chi.subsets?.forEach(subset => {
                if (subset && !subsets.includes(subset)) subsets.push(subset)
            })
        })
    })
    return subsets
}